/**
 * PopupWrapper component.
 *
 * This component is used to wrap a popup with a title, icon, and buttons.
 * It is used to display a popup with a title, icon, and buttons.
 */

import React from "react";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import { Toolbar, Item } from "devextreme-react/toolbar";

/**
 * Props:
 * - title: The title of the popup.
 * - icon: The icon of the popup.
 * - isVisible: Whether the popup is visible.
 * - onConfirm: The function to call when the confirm button is clicked.
 * - onCancel: The function to call when the cancel button is clicked.
 * - width: The width of the popup.
 * - height: The height of the popup.
 * - children: The children of the popup.
 * - isConfirmDisabled: Whether the confirm button is disabled.
 * - isCancelDisabled: Whether the cancel button is disabled.
 * - showLoading: Whether to show loading state.
 */
const PopupWrapper = ({
  title,
  icon,
  isVisible,
  onConfirm,
  onCancel,
  width,
  height,
  children,
  isConfirmDisabled = false,
  isCancelDisabled = false,
  showLoading = false,
}) => {
  const renderTitle = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {icon && (
          <i
            className={`dx-icon dx-icon-${icon}`}
            style={{ fontSize: "24px", marginRight: "10px" }}
          ></i>
        )}
        <h1 style={{ fontSize: "1.2rem", fontWeight: "600", marginTop: "8px" }}>
          {title}
        </h1>
      </div>
    );
  };

  return (
    <Popup
      visible={isVisible}
      titleRender={renderTitle}
      hideOnOutsideClick={false}
      showTitle={true}
      onCancel={onCancel}
      resizeEnabled={false}
      dragEnabled={true}
      width={width}
      height={height}
    >
      {/* Corps dynamique */}
      <div className="popup-body" style={{ paddingBottom: "30px" }}>
        {children}
      </div>

      {/* Boutons en bas avec Toolbar */}
      <Toolbar
        className="popup-footer"
        style={{
          position: "absolute",
          right: "25px",
          bottom: "10px",
        }}
      >
        <Item location="after">
          <Button
            text="Close"
            onClick={onCancel}
            type="danger"
            disabled={isCancelDisabled}
          />
        </Item>
        <Item location="after">
          <Button
            text={showLoading ? "Loading..." : "Confirm"}
            onClick={onConfirm}
            type="success"
            disabled={isConfirmDisabled}
          />
        </Item>
      </Toolbar>
    </Popup>
  );
};

export default PopupWrapper;
